<p class="modal-subtitle">{{ 'aumico_notes_super_table_add_row_menu_sub_title' | i18next }}</p>
<ul class="selection-list">
    <li (click)="selectOption(superTableAddRow.BALANCE)" class="selection-item" data-testid="super-table-add-row-balance">
        {{ 'aumico_notes_super_table_add_row_menu_option_select_from_balance' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.INCOME)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_select_from_income' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.SEGMENT)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_create_segments' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.TITLE)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_title_row' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.TEXT_ROW)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_text_row' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.SPACE)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_space_row' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.CALCULATION)" class="selection-item" data-testid="super-table-add-row-calculation">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_calculation' | i18next }}
    </li>
    <li (click)="selectOption(superTableAddRow.FREE_TEXT)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_free_text_row' | i18next }}
    </li>
    <li *ngIf="fxEnabled" (click)="selectOption(superTableAddRow.RATE)" class="selection-item">
        {{ 'aumico_notes_super_table_add_row_menu_option_add_rate' | i18next }}
    </li>
</ul>
